const CLASS_FOCUSED: string = 'focused';

function main(): void
{
	const form = document.querySelector('header>div.container>div.scroll>form.search') as HTMLFormElement;
	
	if (!form)
	{
		return;
	}
	
	const inputSearch = form.querySelector('input') as HTMLInputElement;
	// const query = window.location.search;
	// const value = query.match(/[^\=]+$/);
	
	if ( inputSearch.value )
	{
		// inputSearch.value = decodeURIComponent(value[0]);
		toggleClass(form, true, inputSearch);
	}
	
	registerHandlers(form, inputSearch);
}

function registerHandlers(form: HTMLFormElement, inputSearch: HTMLInputElement): void
{
	inputSearch.addEventListener( 'focus', () => toggleClass(form, true, inputSearch) );
	inputSearch.addEventListener('blur', () => toggleClass(form, false, inputSearch));
	
	form.addEventListener( 'submit', (event: Event) => reuireForm( inputSearch, event ) );
}

function toggleClass(form: HTMLFormElement, bool: boolean, inputSearch: HTMLInputElement): void
{
	const value: string = inputSearch.value;

	if (bool === true)
	{
		form.classList.add(CLASS_FOCUSED);
	}
	else
	{
		if (value === '') 
		{
			form.classList.remove(CLASS_FOCUSED);
		}
	}	
}

function reuireForm( input: HTMLInputElement, event: Event ): void
{
	if ( input.value === '' )
	{
		event.preventDefault();
	}
}

export {
	main as default,
}
